import { jsx } from "react/jsx-runtime";
import TableChartIcon from "@mui/icons-material/TableChart";
import { validateTidalLicense } from "../../base/index.js";
function TableChart(props) {
  return /* @__PURE__ */ jsx(
    TableChartIcon,
    {
      "data-testid": "TableChart",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "TableChart",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
TableChart.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "TableChart"
};
validateTidalLicense();
export {
  TableChart
};
//# sourceMappingURL=TableChart.js.map
